import {Table} from "../../../components/layout";
import {ColumnDef} from "@tanstack/react-table";
import CellRender from "../../../components/layout/table/CellRender";
import {BackendVersion} from "fearless-common/src/backendModels";

const columns: ColumnDef<BackendVersion>[] = [
  {
    id: 'id',
    header: 'ID',
    accessorKey: 'version_id'
  },
  {
    id: 'user',
    header: 'Created by',
    accessorKey: 'user',
    cell: CellRender.FullName,
  },
  {
    id: 'updated_at', accessorKey: 'updated_at', header: 'Date', cell: CellRender.DateTime, enableSorting: true,
  },
  {
    id: 'model',
    accessorKey: 'model_data',
    header: 'Model data',
    cell: ({ getValue }) => {
      const modelData = getValue() as string;
      return <pre style={{ maxWidth: '300px' }}>{JSON.stringify(modelData) || '-'}</pre>
    }
  }
];

export default function Photo51FileVersionsTable({ versions }: {
  versions: BackendVersion[]
}) {
  return (
    <Table memoisedColumns={columns} memoisedData={versions} />
  )
}
